import {
  Alert,
  Badge,
  Center,
  Code,
  Group,
  Loader,
  NativeSelect,
  Stack,
  Table,
  Title,
} from '@mantine/core';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';
import React, { useState } from 'react';
import { useTemplates } from '../api/notifications';

export function NotificationsTemplatesPage() {
  const [filterChannel, setFilterChannel] = useState<string>('All');
  const [filterCategory, setFilterCategory] = useState<string>('All');
  const [expandedId, setExpandedId] = useState<string | null>(null);

  const templates = useTemplates();

  const filtered = (templates.data ?? []).filter((t) => {
    if (filterChannel !== 'All' && t.channel !== filterChannel) return false;
    if (filterCategory !== 'All' && t.category !== filterCategory) return false;
    return true;
  });

  if (templates.isLoading)
    return (
      <Center>
        <Loader />
      </Center>
    );
  if (templates.isError) return <Alert color="red">Failed to load templates</Alert>;

  return (
    <Stack gap="lg">
      <Title order={2}>Templates</Title>
      <Group gap="sm">
        <NativeSelect
          label="Channel"
          data={['All', 'email', 'slack', 'webhook']}
          value={filterChannel}
          onChange={(e) => setFilterChannel(e.currentTarget.value)}
        />
        <NativeSelect
          label="Category"
          data={['All', 'transactional', 'clinical', 'marketing', 'operational']}
          value={filterCategory}
          onChange={(e) => setFilterCategory(e.currentTarget.value)}
        />
      </Group>
      <Table striped highlightOnHover>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Code</Table.Th>
            <Table.Th>Channel</Table.Th>
            <Table.Th>Category</Table.Th>
            <Table.Th>Subject</Table.Th>
            <Table.Th>PHI</Table.Th>
            <Table.Th>Org</Table.Th>
            <Table.Th />
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {filtered.map((t) => (
            <React.Fragment key={t.id}>
              <Table.Tr
                style={{ cursor: 'pointer' }}
                onClick={() => setExpandedId(expandedId === t.id ? null : t.id)}
              >
                <Table.Td>{t.code}</Table.Td>
                <Table.Td>{t.channel}</Table.Td>
                <Table.Td>{t.category}</Table.Td>
                <Table.Td>{t.subject ?? '—'}</Table.Td>
                <Table.Td>{t.phi ? <Badge color="red">PHI</Badge> : null}</Table.Td>
                <Table.Td>{t.orgId ?? '—'}</Table.Td>
                <Table.Td>
                  {expandedId === t.id ? (
                    <IconChevronUp size={16} />
                  ) : (
                    <IconChevronDown size={16} />
                  )}
                </Table.Td>
              </Table.Tr>
              {expandedId === t.id && (
                <Table.Tr>
                  <Table.Td colSpan={7} style={{ background: 'var(--mantine-color-gray-0)' }}>
                    <Code block style={{ maxHeight: 300, overflowY: 'auto' }}>
                      {t.bodyTemplate}
                    </Code>
                  </Table.Td>
                </Table.Tr>
              )}
            </React.Fragment>
          ))}
        </Table.Tbody>
      </Table>
    </Stack>
  );
}
